<div class="uk-position-relative wrap">
    <div class="uk-margin-medium-top tab">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="menu.active.tab === 'activity'">
                <a (click)="menu.setMenuState('dashboard', '', 'activity')">Activité</a>
            </li>
            <li [class.uk-active]="menu.active.tab === 'map'">
                <a (click)="menu.setMenuState('dashboard', '', 'map')">Carte</a>
            </li>
            <li [class.uk-active]="menu.active.tab === 'message'">
                <a (click)="menu.setMenuState('dashboard', '', 'message')">Messagerie</a>
            </li>
            <!-- <li [class.uk-active]="menu.active.tab === 'info'">
                <a (click)="menu.setMenuState('dashboard', '', 'info')">Infos</a>
            </li> -->
        </ul>
    </div>
</div>